/**
 * Runtime configuration, read from `window.__ADA__` (set by the backend's `/config.js`, loaded
 * before the bundle in index.html). Nothing here is baked in at build time: the same image is
 * promoted from dev to prod. The fallbacks only serve `npm run dev` against a local stack.
 */
export interface AppConfig {
  keycloakUrl: string;
  keycloakRealm: string;
  keycloakClientId: string;
  environment: string;
  publicUrl: string;
  mcpUrl: string;
  version: string;
  /** Identity provider to jump straight to (e.g. "entra"); "" = Keycloak login form. */
  idpHint: string;
}

function text(value: unknown, fallback: string): string {
  return typeof value === "string" && value.trim() !== "" ? value.trim() : fallback;
}

export function readConfig(raw: AdaRuntimeConfig | undefined, origin: string): AppConfig {
  const publicUrl = text(raw?.publicUrl, origin).replace(/\/+$/, "");
  return {
    keycloakUrl: text(raw?.keycloakUrl, "http://localhost:8080/auth").replace(/\/+$/, ""),
    keycloakRealm: text(raw?.keycloakRealm, "ada"),
    keycloakClientId: text(raw?.keycloakClientId, "web"),
    environment: text(raw?.environment, "local"),
    publicUrl,
    mcpUrl: text(raw?.mcpUrl, `${publicUrl}/mcp`),
    version: text(raw?.version, "dev"),
    // An empty string is meaningful (local: the seeded accounts log in with the form).
    idpHint: typeof raw?.idpHint === "string" ? raw.idpHint.trim() : "",
  };
}

export const config: AppConfig = readConfig(
  typeof window !== "undefined" ? window.__ADA__ : undefined,
  typeof window !== "undefined" ? window.location.origin : "http://localhost:5173",
);
